module.exports = __webpack_public_path__ + "media/tipIcon.a8742d8c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/app-website/assets/tipIcon.svg
// module id = ./src/templates/app-website/assets/tipIcon.svg
// module chunks = 0